export class ControleEstoqueDetalheSeriesRequest {
  searchText?: string;
  idLocalizacaoEstoque?: number | null;
  dataInicial?: string | null;
  dataFinal?: string | null;
  idStatusFiltro: number = 0;
}
